// import * as Font from 'expo-font';
// import * as SplashScreen from 'expo-splash-screen';
// import { Ionicons, MaterialIcons, MaterialCommunityIcons } from '@expo/vector-icons';
// import { Ionicons } from '@expo/vector-icons';
import * as React from 'react';

export function useCachedResources() {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);

  // Load any resources or data that we need prior to rendering the app
  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        // SplashScreen.preventAutoHideAsync();

        // Load fonts
        // await Font.loadAsync({
          //   Roboto: require('native-base/Fonts/Roboto.ttf'),
          //   Roboto_medium: require('native-base/Fonts/Roboto_medium.ttf'),
          // ...Ionicons.font,
          // ...MaterialIcons.font,
          // ...MaterialCommunityIcons.font,
        // });
      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
        // SplashScreen.hideAsync();
      }
    }

    loadResourcesAndDataAsync();
  }, []);

  return isLoadingComplete;
}
